<template>
  <div class="w-100">
    <div v-show="loader0 || loader || loader1">
      <Loader />
    </div>
    <div class="datepickerwrap card">
      <div class="mb-2">
        <h4 class="borderBottom pb-2 graphHeading">Sellers Share</h4>
        <!-- <span class="lastUpdated">
                    Last Updated: {{ lastUpdated }}
                </span> -->
      </div>
      <div class="d-flex flex-wrap">
        <div>
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            Date Range
          </div>
          <date-range-picker
            v-model="pieDateRange"
            :show-dropdowns="true"
            opens="right"
            :autoApply="true"
            :locale-data="{ format: 'dd mmm yyyy' }"
            :min-date="minDate"
            :max-date="maxDate"
            :ranges="false"
          >
          </date-range-picker>
        </div>
        <div class="customSelect mx-2" style="width: 150px">
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            Platform
          </div>
          <select
            @change="changePlatform"
            v-model="selectedPiePlatform"
            class="form-control text-uppercase"
          >
            <option
              v-for="platform of platforms"
              :key="platform"
              :value="platform"
            >
              {{ platform.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
        <div class="customSelect mr-2" style="width: 150px">
          <div
            class="mb-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            Category
          </div>
          <select
            v-model="selectedPieCategory"
            @change="getPiePinList('platformChange')"
            class="form-control text-uppercase"
          >
            <option
              v-for="category of categoryPieList"
              :key="category"
              :value="category"
            >
              {{ category.replaceAll("_", " ") }}
            </option>
          </select>
        </div>
        <div class="customMultiselect mr-2" style="width: 250px">
          <div
            class="mb-1 ml-2"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            Product ID
          </div>
          <multiselect
            v-model="selectedPieASIN"
            :options="pieASINList"
            label="sku"
            :multiple="false"
            :searchable="true"
            placeholder="Select Product ID"
            selectLabel=""
            deselectLabel="Remove"
            track-by="sku"
            name="sku"
            :close-on-select="true"
          >
          </multiselect>
        </div>

        <!-- <div class="d-flex w-50"> -->
        <!-- <div class="customMultiselect mr-2">
                        <multiselect v-model="selectedASIN" :options="ASINList" :multiple="true" :searchable="false"
                            placeholder="Select ASIN to filter" selectLabel="" deselectLabel="Remove" @input=""
                            :close-on-select="false">
                            <template slot="option" slot-scope="{ option }">
                                <input type="checkbox" :value="option" v-model="selectedASIN">
                                <span class="option__title ml-3">{{ option }}</span>
                            </template>
</multiselect>
</div> -->
        <div
          class="custom_pincode_dropdown customMultiselect"
          style="width: 200px"
        >
          <div
            class="mb-1 ml-1"
            style="font-size: 14px; font-weight: 500; color: #1e1e1e"
          >
            Pincode
          </div>
          <multiselect
            v-model="selectedPiePIN"
            :options="piePINList"
            :multiple="true"
            group-values="pincodes"
            group-label="city"
            :group-select="true"
            placeholder="Search PIN"
            select-label=""
            deselect-label="Remove"
            selectedLabel="selected"
            :closeOnSelect="false"
            selectGroupLabel=""
            deselectGroupLabel=""
            @input="changePieSelectInput"
          >
            <template slot="beforeList">
              <div
                class="d-flex align-items-center py-2 px-1 allSelect"
                @click="selectAllPiePin"
              >
                <input type="checkbox" class="mx-2" v-model="allPiePin" />
                <span class="ml-2">All</span>
              </div>
            </template>
            <template slot="option" slot-scope="{ option }">
              <div v-if="option.$isLabel">
                <strong>{{ option.$groupLabel }}</strong>
              </div>
              <div v-else>
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedPiePIN"
                />
                <span class="option__title ml-3">{{ option }}</span>
              </div>
            </template>
          </multiselect>
        </div>
        <div class="mt-4 ml-3">
          <button @click="handleApplyFilter" class="btn primarycolor py-2">
            Apply Filter
          </button>
        </div>
        <!-- </div> -->
      </div>

      <div class="card mx-2 mt-4">
        <!-- <h4 class="borderBottom graphHeading pb-3">Sellers Share</h4> -->
        <div v-if="Object.keys(processedPieChartData).length">
          <highcharts :options="processedPieChartData" />
        </div>
      </div>
    </div>
    <div class="row datepickerwrap card">
      <h4 class="borderBottom graphHeading pb-3">Buybox Monitor</h4>
      <div
        class="d-flex justify-content-between mt-3 align-items-center flex-wrap gap-4"
      >
        <div class="d-flex gap-3 flex-wrap">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Date
            </div>
            <date-range-picker
              style="width: 150px"
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDate"
              :max-date="maxDate"
              :single-date-picker="true"
              :ranges="false"
              @update="getBuyBoxTable"
            >
            </date-range-picker>
          </div>
          <div class="customSelect mr-2" style="width: 150px">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Platform
            </div>
            <select
              @change="changeBuyBoxTableFilter('platformChange')"
              v-model="selectedPlatform"
              class="form-control text-uppercase"
            >
              <option
                v-for="platform of platforms"
                :key="platform"
                :value="platform"
              >
                {{ platform.replaceAll("_", " ") }}
              </option>
            </select>
          </div>
          <div class="customSelect mx-2" style="width: 150px">
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Category
            </div>
            <select
              v-model="selectedTableCategory"
              @change="changeBuyBoxTableFilter('categoryChange')"
              class="form-control text-uppercase"
            >
              <option
                v-for="category of categoryTableList"
                :key="category"
                :value="category"
              >
                {{ category.replaceAll("_", " ") }}
              </option>
            </select>
          </div>
          <div class="customMultiselect mr-2" style="width: 13rem">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Product ID
            </div>
            <multiselect
              v-model="selectedASIN"
              :options="ASINList"
              :multiple="true"
              :searchable="true"
              placeholder="Select Product ID"
              selectLabel=""
              deselectLabel="Remove"
              :close-on-select="false"
              track-by="sku"
              name="sku"
              label="sku"
            >
              <template slot="option" slot-scope="{ option }">
                <input type="checkbox" :value="option" v-model="selectedASIN" />
                <span class="option__title ml-3">{{ option.sku }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="custom_pincode_dropdown customMultiselect"
            style="width: 150px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Pincode
            </div>
            <multiselect
              v-model="selectedPIN"
              :options="PINList"
              :multiple="true"
              group-values="pincodes"
              group-label="city"
              :group-select="true"
              placeholder="Search PIN(s)"
              select-label=""
              deselect-label=""
              selectedLabel=""
              :closeOnSelect="false"
              selectGroupLabel="Select Group"
              deselectGroupLabel="Deselect Group"
              @input="changeSelectInput"
            >
              <template slot="beforeList">
                <div
                  class="d-flex align-items-center py-2 px-1 allSelect"
                  @click="selectAllPIN"
                >
                  <input type="checkbox" class="mx-2" v-model="allPIN" />
                  <span class="ml-2">All</span>
                </div>
              </template>
              <template slot="option" slot-scope="{ option }">
                <div v-if="option.$isLabel">
                  <strong>{{ option.$groupLabel }}</strong>
                </div>
                <div v-else>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPIN"
                  />
                  <span class="option__title ml-3">{{ option }}</span>
                </div>
              </template>
            </multiselect>

            <!-- <div style="text-align: center; background-color: var(--primary_brand); height: 35px; width: 180px;  padding-top: 6px; margin-right: 1rem;"
                            class="btn text-white font-weight-bold checkboxAccent" @click="getPincodeAnalysis">
                            <input v-model="pincodeCheck" style="float: left; margin-top: 2.5px; margin-right: 5px"
                                type="checkbox" />
                            <span> Pincode Analysis </span>
                        </div> -->
          </div>
        </div>
        <div class="d-flex">
          <div class="mr-2">
            <button class="btn primarycolor py-2" @click="getBuyBoxTable">
              Submit
            </button>
          </div>
          <div class="">
            <button class="btn primarycolor py-2" @click="resetTable">
              Reset
            </button>
          </div>
          <!-- <button @click="downloadStandardExel" class="mt-4 btn primarycolor">Download</button> -->
          <!-- <button @click="downloadLastExel" class="ui button exportButton ml-1">Export last 2 months</button> -->
        </div>
      </div>
      <div
        class="mt-2"
        style="overflow: hidden; width: 100%; position: relative"
      >
        <table
          id="buybox_table"
          v-if="tableData.length"
          style="min-width: 1400px; margin-right: 1px"
        >
          <thead class="thead-normal">
            <tr>
              <th v-for="header of tableHeader" :key="header.key">
                {{ header.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row1, index) of tableData" :key="index">
              <td style="min-width: 300px">
                <div>{{ row1.asin }}</div>
                <a :href="row1.product_link" target="_blank">
                  <span
                    style="
                      font-style: italic;
                      color: rgb(22, 116, 149);
                      font-weight: 500;
                      padding-inline: 15px;
                      cursor: pointer;
                    "
                  >
                    {{ row1.product_name }}
                  </span>
                </a>
              </td>
              <td
                v-for="header of tableHeader.slice(1, tableHeader.length)"
                :class="computeClass(header.key)"
                :key="header.key"
              >
                <div
                  v-for="row2 of row1.asin_data"
                  class="inner-row d-flex"
                  :key="row2"
                  :class="
                    header.key === 'all_offers'
                      ? ''
                      : 'justify-content-center align-items-center'
                  "
                >
                  <div v-if="header.key === 'action'">
                    <div class="mb-1">
                      <b>Other Sellers:&nbsp;</b>{{ row2.other_sellers }}
                    </div>
                    <div v-if="row2.other_sellers > 0">
                      <a
                        @click="
                          showSellerModal(
                            row1.asin,
                            row2.pincode,
                            row1.product_name
                          )
                        "
                        style="color: rgb(22, 116, 149); cursor: pointer"
                      >
                        <i
                          class="fa fa-external-link"
                          style="font-size: 14px"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <ul v-else-if="header.key === 'all_offers'">
                    <li
                      class="text-left"
                      v-for="offer of row2['all_offers']"
                      :key="offer"
                    >
                      {{ offer }}
                    </li>
                  </ul>
                  <div v-else>{{ row2[header.key] || "-" }}</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="noData text-danger" v-else>No Data Available.</div>
      </div>

      <!-- <table id="buybox_table" v-if="tableData.length">
                <thead>
                    <tr>
                        <th v-for="header of tableHeader" :key="header.key">{{ header.label }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row1, index) of tableData" :key="index">
                        <td>{{ row1.asin }}</td>
                        <td v-for="col of tableHeader.slice(1, tableHeader.length)" :key="index+col.key">
                            <table style="width: 100%;">
                                <tr v-for="(row2, idx) of row1.asin_data" :key="idx+index">
                                    <td style="height: 20px !important;">{{ row2[col.key] }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table> -->
    </div>
    <b-modal
      size="xl"
      v-model="isSellerModal"
      style="z-index: 3000 !important"
      class="customModal"
    >
      <template #modal-title>
        <div
          style="
            text-transform: capitalize;
            width: 600px;
            text-overflow: ellipsis;
          "
          :title="sellerModalTitle"
        >
          {{ sellerModalTitle }}
        </div>
      </template>
      <table id="seller_table" class="w-100">
        <thead class="thead-normal">
          <tr>
            <th v-for="header of otherSellersTableHeader" :key="header.key">
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) of otherSellersTableData" :key="index">
            <td v-for="col of otherSellersTableHeader" :key="col.key">
              {{ row[col.key] }}
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import pieChart from "../commonCharts/pieChart.vue";
import Loader from "../Components/Loader.vue";
export default {
  name: "BuyboxMonitor",
  components: {
    Multiselect,
    Datepicker,
    pieChart,
    Loader,
  },
  data() {
    return {
      tableHeader: [],
      tableData: [],
      ASINList: [],
      pieASINList: [],
      selectedASIN: "",
      selectedPieASIN: {},
      PINList: [],
      selectedPIN: "",
      piePINList: [],
      selectedPiePIN: [],
      loader: false,
      loader0: false,
      loader1: false,
      isSellerModal: false,
      sellerModalTitle: "",
      otherSellersTableHeader: [],
      otherSellersTableData: [],
      pieDateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      dateRange: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      disabledDates: {
        to: new Date("2024-03-30"),
        from: new Date(),
      },
      pincodeCheck: false,
      lastUpdated: "",
      client: JSON.parse(localStorage.reviewUserData).data.client,
      platforms: ["amazon_retail", "flipkart_grocery"],
      selectedPlatform: "amazon_retail",
      selectedPiePlatform: "amazon_retail",
      categoryPieList: "",
      categoryTableList: "",
      selectedPieCategory: "",
      selectedTableCategory: "",
      asinChange: false,
      pinChange: false,
      processedPieChartData: {},
      color_codes: [
        "#6AB7A8",
        "#90C8BE",
        "#B5DBD4",
        "#9ABABC",
        "#6A999B",
        "#6A999B80",
        "#CCDCDD",
        "#E6EDEE",
        "#F1F5F5",
        "#DAEDE9",
      ],
      allPIN: false,
      allPiePin: false,
    };
  },
  mounted() {
    if (JSON.parse(localStorage.reviewUserData).data.buybox_channels) {
      this.platforms = JSON.parse(
        localStorage.reviewUserData
      ).data.buybox_channels;
      this.selectedPiePlatform = this.platforms[0];
      this.selectedPlatform = this.platforms[0];
    }
    if (JSON.parse(localStorage.demo_voc_product_list)) {
      this.categoryPieList = this.categoryTableList = Object.keys(
        JSON.parse(localStorage.demo_voc_product_list)[this.selectedPiePlatform]
      );
      this.selectedPieCategory = this.selectedTableCategory =
        this.categoryPieList[0];
    }

    this.getLastUpdatedDates();

    // this.changePieCategory();
    // this.changeTableCategory();
    this.resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    if (this.$refs.chartContainer) {
      this.resizeObserver.observe(this.$refs.chartContainer);
    }
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    changePlatform() {
      this.categoryPieList = [];
      this.pieASINList = [];
      this.selectedPieASIN = {};
      this.piePINList = [];
      this.selectedPiePIN = [];
      this.allPiePin = false;

      if (JSON.parse(localStorage.demo_voc_product_list)) {
        this.categoryPieList = Object.keys(
          JSON.parse(localStorage.demo_voc_product_list)[
            this.selectedPiePlatform
          ]
        );
        this.selectedPieCategory = this.categoryPieList[0];
      }
      this.getPiePinList("platformChange");
    },
    changePieCategory() {
      this.pieASINList = [];
      this.selectedPieASIN = {};
      this.piePINList = [];
      this.selectedPiePIN = [];
      this.allPiePin = false;
    },
    changeTableCategory() {
      if (JSON.parse(localStorage.demo_voc_product_list)) {
        this.categoryTableList = Object.keys(
          JSON.parse(localStorage.demo_voc_product_list)[this.selectedPlatform]
        );
        this.selectedTableCategory = this.categoryTableList[0];
      }
    },
    resizeChart() {
      if (this.$refs.chart.chart) {
        this.$refs.chart.chart.reflow();
      }
    },
    changeSelectInput() {
      let length = 0;
      this.PINList.forEach((PINGroup) => {
        length += PINGroup.pincodes.length;
      });

      if (length === this.selectedPIN.length) {
        this.allPIN = true;
      } else {
        this.allPIN = false;
      }
    },
    changePieSelectInput() {
      let length = 0;
      this.piePINList.forEach((PINGroup) => {
        length += PINGroup.pincodes.length;
      });

      if (length === this.selectedPiePIN.length) {
        this.allPiePin = true;
      } else {
        this.allPiePin = false;
      }
    },
    selectAllPIN() {
      this.allPIN = !this.allPIN;
      this.selectedPIN = [];
      if (this.allPIN) {
        this.PINList.forEach((PINGroup) => {
          this.selectedPIN = [...this.selectedPIN, ...PINGroup.pincodes];
        });
      }
    },
    selectAllPiePin() {
      this.allPiePin = !this.allPiePin;
      this.selectedPiePIN = [];
      if (this.allPiePin) {
        this.piePINList.forEach((PINGroup) => {
          this.selectedPiePIN = [...this.selectedPiePIN, ...PINGroup.pincodes];
        });
      }
    },
    resetTable() {
      this.selectedASIN = "";
      this.selectedPIN = "";
      this.allPIN = "";
      this.getBuyBoxTable();
    },
    computeClass(key) {
      if (key === "all_offers") {
        return "expanded-col";
      } else if (key === "eta") {
        return "mid-col";
      } else return "inner-cols";
    },
    getLastUpdatedDates() {
      this.loader0 = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.buybox_monitor) {
            localStorage.buybox_monitor_last_update = JSON.stringify(
              response.body.data.buybox_monitor
            );
            this.dateRange.endDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.pieDateRange.endDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.pieDateRange.startDate = moment(
              response.body.data.buybox_monitor.end_date
            ).format("YYYY-MM-DD");
            this.maxDate = new Date(response.body.data.buybox_monitor.end_date);
            this.minDate = new Date(
              response.body.data.buybox_monitor.start_date
            );
            this.lastUpdated = `${moment(
              response.body.data.buybox_monitor.end_date
            ).format("DD MMM, YYYY")} ${
              response.body.data.buybox_monitor.latest_time ? "at" : ""
            } ${response.body.data.buybox_monitor.latest_time}`;
            this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);
          }
          this.loader0 = false;
          this.getBuyBoxTable();
          this.getPieChartsData();
        },
        (err) => {
          this.loader0 = false;
          this.getBuyBoxTable();
          console.log("err");
        }
      );
    },
    downloadStandardExel() {
      let self = this;
      this.loader = true;
      let payload = {
        pincodes: [],
        asins: [],
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform,
        pincode_analysis: this.pincodeCheck,
        category: this.selectedTableCategory,
      };
      if (this.selectedASIN.length) {
        payload["asins"] = this.selectedASIN;
      }

      if (this.selectedPIN.length) {
        payload["pincodes"] = this.selectedPIN;
      }

      const url = "/api/v2/indian_clients/buy_box/data/report";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.data;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    getPieChartsData() {
      this.loader1 = true;
      this.processedPieChartData = {};

      const url = "/api/v2/indian_clients/buy_box/data/pie_charts";
      const payload = {
        pincodes: this.selectedPiePIN,
        // pincodes: [],
        asin: this.selectedPieASIN,
        client: this.client,
        category: this.selectedPieCategory,
        timestamp: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        start_date: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.pieDateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.piePINList = response.body.data.pincode_list;
          this.selectedPiePIN = response.body.data.selected_pincodes;
          this.pieASINList = response.body.data.asin_list;
          this.selectedPieASIN = response.body.data.selected_asin;
          let tempPieChartData = [];
          let processedPieChartData = [];
          if (response.body.data.data.length) {
            Object.values(response.body.data.data).forEach((valObj) => {
              if (valObj.hasOwnProperty("date_range_pie_chart")) {
                tempPieChartData = valObj.date_range_pie_chart;
              }
            });
          } else {
            this.loader1 = false;
            return;
          }
          tempPieChartData.forEach((seriesData, index) => {
            processedPieChartData.push({
              name: seriesData.key.toLowerCase(),
              y: seriesData.doc_count,
              color: seriesData.key
                .toLowerCase()
                .includes(this.client.toLowerCase())
                ? "#FCB117"
                : seriesData.key == "Out of Stock"
                ? "#d66772"
                : this.color_codes[index],
            });
          });
          this.processPieChart(processedPieChartData);
          this.loader1 = false;
        },
        (err) => {
          self.loader1 = false;
          console.log("err");
        }
      );
    },
    getPiePinList(state = "") {
      this.loader1 = true;
      if (state === "platformChange") {
        this.selectedPieASIN = "";
        this.selectedPiePIN = "";
        this.changePieCategory();
      }
      if (state == "ASINChange") {
        this.selectedPiePIN = "";
      }
      const url = "/api/v2/indian_clients/buy_box/data/pie_charts";
      const payload = {
        pincodes: this.selectedPiePIN,
        asin: this.selectedPieASIN,
        client: this.client,
        timestamp: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        start_date: moment(this.pieDateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.pieDateRange.endDate).format("YYYY-MM-DD"),
        channel: this.selectedPiePlatform,
        pincodes: this.selectedPiePIN,
        category: this.selectedPieCategory,
      };
      this.$http.post(url, payload).then(
        (response) => {
          this.piePINList = response.body.data.pincode_list;
          this.selectedPiePIN = response.body.data.selected_pincodes;
          this.pieASINList = response.body.data.asin_list;
          this.selectedPieASIN = response.body.data.selected_asin;
          this.loader1 = false;
        },
        (err) => {
          this.loader1 = false;
          console.log("err");
        }
      );
    },
    processPieChart(data) {
      let self = this;

      self.processedPieChartData = {
        chart: {
          marginTop: 60,
          marginBottom: 20,
        },
        title: {
          text: "",
          verticalAlign: "bottom",
          style: { fontSize: 15, fontWeight: "600", color: "#01695C" },
        },
        exporting: {
          enabled: false,
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="font-size:22px;color:' +
              this.point.color +
              '">\u25CF</span> ';
            mytooltip +=
              '<span style="text-transform: capitalize">' +
              this.point.name +
              "</span>";
            mytooltip += " : <b> " + this.point.y;
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              useHTML: true,
              formatter: function () {
                return (
                  '<span style="color:black;font-size:14px;font-weight:normal;">' +
                  this.point.percentage.toFixed() +
                  "%</span>"
                );
              },
              distance: -25,
              style: {
                fontSize: 11,
              },
            },
            showInLegend: true,
            size: "100%",
          },
        },
        legend: {
          alignColumns: true,
          align: "right",
          y: 0,
          x: 0,
          squareSymbol: true,
          verticalAlign: "top",
          itemDistance: 35,
          margin: 0,
          padding: 0,
          symbolHeight: 14,
          symbolWidth: 14,
          symbolRadius: 4,
          itemStyle: {
            textTransform: "capitalize",
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: data,
          },
        ],
      };
    },
    changeBuyBoxTableFilter(state = "") {
      this.loader = true;
      if (state === "categoryChange") {
        this.selectedASIN = "";
        this.ASINList = [];
        this.selectedPIN = [];
        // this.changeTableCategory()
      }
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: [],
        asins: [],
        category: this.selectedTableCategory,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform,
        // pincode_analysis: this.pincodeCheck
      };

      if (this.selectedASIN.length) {
        payload["asins"] = this.selectedASIN;
      }

      if (state === "platformChange") {
        this.selectedPIN = [];
        this.changeTableCategory();
      }

      if (this.selectedPIN.length) {
        payload["pincodes"] = this.selectedPIN;
      }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.ASINList = res.body.data.asin_list;
          this.PINList = res.body.data.pincode_list;
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast(`Error: Check console for detailed info.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          this.loader = false;
        });
    },
    getBuyBoxTable(state = "") {
      this.loader = true;

      $("#buybox_table").DataTable().destroy();

      if (state === "categoryChange") {
        this.selectedASIN = "";
        this.ASINList = [];
        this.selectedPIN = [];
        // this.changeTableCategory()
      } else {
        this.tableData = [];
        this.tableHeader = [];
      }
      const url = "/api/v2/indian_clients/buy_box/data/primary";
      const payload = {
        pincodes: [],
        asins: [],
        category: this.selectedTableCategory,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform,
        // pincode_analysis: this.pincodeCheck
      };

      if (this.selectedASIN.length) {
        payload["asins"] = this.selectedASIN;
      }

      if (state === "platformChange") {
        this.selectedPIN = [];
        this.changeTableCategory();
      }

      if (this.selectedPIN.length) {
        payload["pincodes"] = this.selectedPIN;
      }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.ASINList = res.body.data.asin_list;
          this.PINList = res.body.data.pincode_list;

          if (state == "categoryChange" || state == "platformChange") {
            this.loader = false;
            return false;
          }
          if (!Object.keys(res.body.data).length) {
            this.$bvToast.toast(`No Data available.`, {
              title: "Weavr Sense",
              variant: "danger",
              toaster: "b-toaster-top-right",
              autoHideDelay: 3000,
            });
            this.loader = false;
            return;
          } else {
            this.tableHeader = res.body.data.headers;
            this.tableData = res.body.data.data;
            if (!this.selectedPIN.length)
              this.selectedPIN = res.body.data.selected_pincodes;

            this.tableHeader.push({
              key: "action",
              label: "View Other Sellers",
            });

            this.$nextTick(() => {
              $("#buybox_table").DataTable({
                initComplete: function (settings, json) {
                  $(".dataTables_scrollBody tfoot tr").css({
                    visibility: "collapse",
                  });
                  $(".dataTables_scrollBody thead tr").css({
                    visibility: "collapse",
                  });
                  $("#buybox_table").wrap(
                    "<div style='overflow:auto; width:100%;position:relative;'></div>"
                  );
                },
                language: {
                  search: "",
                  paginate: {
                    first: "",
                    previous: "<",
                    next: ">",
                    last: "",
                  },
                  lengthMenu: "<h5>Show entries</h5> _MENU_",
                  searchPlaceholder: "Search...",
                },
                // dom: '<"top">frt<"bottom"l>p<"clear">',
                pagingType: "full_numbers",
                searching: true,
                sorting: [[1, "asc"]],
                autoWidth: false,
              });

              let search = require("../../../public/Icons_SVG/Search.svg");
              $("#buybox_table_filter > label").append(
                `<div><img src='${search}' /></div>`
              );

              var btn = $(
                '<input type="button" class="btn downloadBtn" value="Download" id="downloadBtn"/>'
              );
              $("#buybox_table_filter > label").append(btn);

              $("#downloadBtn").click(() => {
                this.downloadStandardExel();
              });
            });
          }
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast(`Error: Check console for detailed info.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          this.loader = false;
        });
    },

    showSellerModal(asin, pincode, productName) {
      this.loader = true;
      const url = "/api/v2/indian_clients/buy_box/data/other";
      const payload = {
        pincode: pincode,
        asin: asin,
        category: this.selectedTableCategory,
        client: this.client,
        timestamp: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        channel: this.selectedPlatform,
      };

      // if (!this.pincodeCheck) {
      //     this.sellerModalTitle = `${asin}`
      // } else {
      this.sellerModalTitle = `${productName} - ${pincode}`;
      // }

      this.$http
        .post(url, payload)
        .then((res) => {
          this.otherSellersTableHeader = res.body.data.headers;
          this.otherSellersTableData = res.body.data.data;
          this.isSellerModal = true;
          this.$nextTick(() => {
            $("#seller_table").DataTable({
              language: {
                search: "",
                paginate: {
                  first: "",
                  previous: "<",
                  next: ">",
                  last: "",
                },
                lengthMenu: "<h5>Show entries</h5> _MENU_",
                searchPlaceholder: "Search...",
              },
              // dom: '<"top">frt<"bottom"l>p<"clear">',
              pagingType: "full_numbers",
              searching: true,
              sorting: false,
              autoWidth: false,
              info: false,
            });
            let search = require("../../../public/Icons_SVG/Search.svg");
            $("#seller_table" + "_filter > label").append(
              `<div><img src='${search}' /></div>`
            );
          });
          this.loader = false;
        })
        .catch((err) => {
          console.log(err);
          this.$bvToast.toast(`Error: Check console for detailed info.`, {
            title: "Weavr Sense",
            variant: "danger",
            toaster: "b-toaster-top-right",
            autoHideDelay: 3000,
          });
          this.loader = false;
        });
    },
    handleApplyFilter() {
      this.getPieChartsData();
    },
  },
};
</script>
<style scoped>
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

.custom_dropdown {
  text-transform: uppercase;
}

.custom_pincode_dropdown,
.custom_dropdown {
  -youbkit-touch-callout: none;
  /* iOS Safari */
  -youbkit-user-select: none;
  /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE 10+ and Edge */
  user-select: none;
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

#buybox_table .inner-row::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 5px;
  background: #ebedee;
}

#buybox_table .inner-row::-webkit-scrollbar {
  height: 10px;
  width: 5px;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

#buybox_table .inner-row::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.customMultiselect {
  width: 20%;
}

@media (max-width: 1650px) {
  .customMultiselect {
    width: 22%;
  }

  .lastUpdated {
    background: var(--base_color-60);
    color: white;
    font-size: 13px;
    line-height: 26px;
    padding: 4px 10px;
    border-radius: 4px;
    height: 35px;
  }
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButtonSmall {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bold;
  padding: 0px 10px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButtonSmall:hover {
  background: var(--accent_color-80);
}

.inner-row:not(:last-child) {
  border-bottom: 1px solid var(--base_color-20) !important;
}

.expanded-col {
  min-width: 500px;
}

.mid-col {
  min-width: 300px;
}

.inner-row {
  height: 80px !important;
  overflow-y: auto;
}

.inner-cols {
  min-width: 120px;
  width: 10% !important;
}

@media (max-width: 1450px) {
  .inner-cols {
    width: 12% !important;
  }
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#buybox_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#buybox_table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#buybox_table_info {
  position: relative;
  top: 9px;
  /* left: 324px; */
  left: 0;
  z-index: 100;
  /* float: right; */
  float: none;
  /* width: 50vw; */
  width: auto;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#buybox_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#buybox_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#buybox_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#buybox_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#buybox_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#buybox_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#buybox_table {
  border-radius: 20px 20px 0 0;
}

#buybox_table .thead-normal,
#buybox_table .thead-normal tr:first-child,
#buybox_table .thead-normal > tr:first-child > th:first-child {
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#buybox_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 500 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: black !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#buybox_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 500 !important;
  text-align: center !important;
  padding: 10px 25px 10px 25px !important;
  color: black !important;
  background-color: rgba(39, 86, 89, 0.1) !important;
}

#buybox_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#buybox_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#buybox_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#buybox_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#buybox_table .even td {
  background: #fff !important;
}

#buybox_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #buybox_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#buybox_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#buybox_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#buybox_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
  display: none;
}

#buybox_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
  display: none;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#buybox_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#buybox_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#buybox_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#buybox_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#buybox_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#buybox_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#buybox_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#buybox_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#buybox_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

/* Modal Table */

#seller_table .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#seller_table_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#seller_table_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#seller_table_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}

#seller_table_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#seller_table_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#seller_table_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#seller_table_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#seller_table_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#seller_table {
  border-radius: 20px 20px 0 0;
}

#seller_table .thead-normal,
#seller_table .thead-normal tr:first-child,
#seller_table .thead-normal > tr:first-child > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:first-child > th:last-child {
  border-radius: 0 21px 0 0;
}

#seller_table .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
}

#seller_table .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 10px 25px 10px 25px !important;
  color: rgb(78 78 78) !important;
}

#seller_table th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#seller_table tfoot th {
  background-color: var(--background) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#seller_table tfoot th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table tbody td {
  /* border-left: 1px solid var(--base_color-20) !important; */
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#seller_table tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#seller_table .even td {
  background: #fff !important;
}

#seller_table .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #seller_table_wrapper .bottom {
  margin-bottom: -30px;
} */
#seller_table_wrapper .row:last-child {
  margin-bottom: 15px;
}

#seller_table_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#seller_table .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 57%;
  color: var(--base_color-80);
}

#seller_table .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  color: var(--base_color-80);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--background);
}

#seller_table_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}

#seller_table_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#seller_table_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#seller_table_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#seller_table_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#seller_table_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#seller_table_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg)
    brightness(103%) contrast(104%);
}

#seller_table_filter div.filter_icon {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  background-color: var(--background);
}

#seller_table_filter div.filter_icon img {
  height: 23px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(18%) saturate(2530%)
    hue-rotate(138deg) brightness(98%) contrast(95%);
}

#buybox_table_filter .downloadBtn {
  margin: 0px 10px;
  height: 35px;
  width: 100px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

.allSelect {
  cursor: pointer;
  color: var(--primary_brand);
}

.allSelect:hover {
  background-color: var(--base_color-20);
}

.customMultiselect .multiselect__placeholder {
  margin-bottom: 6px !important;
  padding: 0px !important;
  color: var(--primary_brand-40) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tags {
  border: 1px solid var(--base_color-40) !important;
  padding-top: 6px !important;
  min-height: 35px !important;
  max-height: 36px !important;
  overflow-y: auto;
  font-family: "poppins";
}

.customMultiselect .multiselect__input {
  border: var(--base_color-20) !important;
  height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
  outline: none !important;
}

.customMultiselect .multiselect__select {
  min-height: 35px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
  top: 56% !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag {
  background: var(--primary_brand-80) !important;
  margin-bottom: 0px !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
  color: #fff !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
  border: 1px solid var(--base_color-40) !important;
  border-top: none !important;
  font-family: "poppins";
}

.customMultiselect
  .multiselect__option--selected.multiselect__option--highlight {
  background: var(--red) !important;
  color: var(--white) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
  background: var(--base_color-20) !important;
  color: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customMultiselect .multiselect__element {
  color: var(--primary_brand-80) !important;
  border-bottom: 1px solid var(--base_color-20);
  font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
  background-color: #44777a !important;
  color: white !important;
  font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
  font-size: 10px !important;
  padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
  width: 10px;
  border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
  background: var(--base_color-20);
  border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
  background: var(--base_color-80);
  border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
  background: var(--base_color);
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.modal-title {
  font-weight: 600 !important;
  font-family: "poppins" !important;
}

.modal-header {
  background: var(--primary_brand-20) !important;
  color: var(--base_color) !important;
  border: none !important;
  font-family: "poppins" !important;
  border-radius: 5px 0px 0px 0px !important;
  word-break: break-all;
}

.modal-header .close {
  color: black !important;
  text-shadow: none !important;
  position: absolute !important;
  top: -2px !important;
  right: -6px !important;
  font-size: 30px !important;
  background: var(--primary_brand-10) !important;
  opacity: inherit !important;
  padding: 5px 10px !important;
  border-radius: 25px !important;
}

@media screen and (max-width: 767px) {
  #buybox_table_paginate {
    float: none;
    width: auto;
  }
}
</style>
